import { useContext, useEffect, useState } from "react";
import {
    Alert,
    Button,
    Card,
    Col,
    Container,
    Row,
    Spinner,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import UploadExcelModal from "./Components/UploadExcelModal";
import { getSapUnpaidInvoices, uploadSapUnpaidInvoices } from "./hooks/api";
import NotyfContext from "../../../../../contexts/NotyfContext";
import DynamicTable from "../../../../../components/version-two-components/DynamicTable";
import { useTableData } from "../../../../../hooks/useTableData";
import { sapUnpaidInvoicesTableColumn } from "./Table/sapUnpaidInvoicesTableColumn";
import Loader2 from "../../../../../components/Loader2";
import { Loader } from "react-feather";
import { useNavigate } from "react-router-dom";

const SapUnpaidInvoice = () => {
    const notyf = useContext(NotyfContext);
    const navigate = useNavigate();

    const [showUploadModal, setShowUploadModal] = useState(false);
    const [uploading, setUploading] = useState(false);

    const { loadingData, error, tableData, tableLinks, tableMeta, fetchData } =
        useTableData(getSapUnpaidInvoices);
    const [searchValue, setSearchValue] = useState({});

    const handleUpload = async (formdata) => {
        try {
            setUploading(true);
            await uploadSapUnpaidInvoices(formdata);
            notyf?.success("File uploaded successfully!");

            setTimeout(async () => {
                await fetchData();
                setShowUploadModal(false);
                setUploading(false);
            }, 15000);
        } catch (error) {}
    };

    // const search = (page) => {
    //     const searcParams = { ...searchValue, ...page };
    //     setSearchValue(searcParams);
    //     fetchData(searcParams);
    // };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    console.log("Data: ", tableData);

    return (
        <>
            <Helmet title="SAP Unpaid Invoices Uploads" />
            <Container fluid>
                <h1 className="h3 mb-3">SAP Unpaid Invoices Uploads</h1>
                <Card>
                    <Card.Header>
                        <Row className="mt-3 mb-4">
                            <Col
                                md={12}
                                className="d-flex justify-content-end gap-2"
                            >
                                <Button
                                    onClick={() =>
                                        navigate(
                                            "/tms/sap-unpaid-invoice-uploads/generate-soa"
                                        )
                                    }
                                    disabled={uploading}
                                >
                                    Generate SOA
                                    {uploading && (
                                        <Spinner
                                            animation="border"
                                            size="sm"
                                            className="ms-2"
                                        />
                                    )}
                                </Button>

                                <Button
                                    onClick={() => setShowUploadModal(true)}
                                    disabled={uploading}
                                >
                                    Upload Excel
                                    {uploading && (
                                        <Spinner
                                            animation="border"
                                            size="sm"
                                            className="ms-2"
                                        />
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        {error && (
                            <Alert variant="danger" className="p-2">
                                {error}
                            </Alert>
                        )}
                        {!error && (
                            <DynamicTable
                                dataPagination={{
                                    data: tableData,
                                    meta: tableMeta,
                                    links: tableLinks,
                                }}
                                columns={sapUnpaidInvoicesTableColumn}
                                isPaginated
                                api={fetchData}
                                isLoading={loadingData}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Container>
            <UploadExcelModal
                show={showUploadModal}
                onClose={() => setShowUploadModal(false)}
                onSubmit={handleUpload}
            />
        </>
    );
};

export default SapUnpaidInvoice;
